<template>
  <div>
    <Widget>
      <form-wizard
        shape="tab"
        color="#3498db"
        title=""
        subtitle=""
        @on-change="updateProgress"
        @on-loading="updateProgress(1, 1)"
      >
        <b-progress
          class="progress-xs"
          variant="info"
          :value="progress"
          :max="2"
        />
        <b-button slot="prev" variant="primary" class="text-white">
          <i class="fa fa-caret-left" /> Sebelumnya
        </b-button>
        <b-button
          slot="next"
          variant="primary"
          id="selanjutnya"
          hidden
          class="text-white"
        >
          Selanjutnya <i class="fa fa-caret-right" />
        </b-button>
        <b-button
          slot="finish"
          variant="success"
          class="text-white"
          @click="finish()"
        >
          Selesai <i class="fa fa-check" />
        </b-button>
        <tab-content
          title="Profil Permohonan"
          style="background-color: white"
        >
         <b-form>
        <legend><strong>Profil</strong></legend>
        <b-row>
          <b-col md="6">
            <b-form-group label-for="form" label="Nama Pemohon: *">
              <b-form-input readonly v-model="form.nama_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="NIK Pemohon: *">
              <b-form-input readonly v-model="form.nik_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Email Pemohon: *">
              <b-form-input readonly v-model="form.email_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Alamat Pemohon: *">
              <b-form-input readonly v-model="form.alamat_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Nomor Permohonan: *">
              <b-form-input readonly v-model="form.nomor_permohonan" type="text" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="NPWP: *">
              <b-form-input v-validate="'required'" name="NPWP" readonly :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.NPWP'),
              }" v-model="form.npwp_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="NIB: *">
              <b-form-input readonly v-model="form.nib_pemohon" type="text" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="No Proyek: *">
              <b-form-input readonly v-model="form.nomor_proyek" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Sektor: *">
              <v-select disabled id="default-select" v-model="form.klasifikasi_pemohon"
                :reduce="(klasifikasi) => klasifikasi.nama" label="nama" :options="dataKlasifikasi"
                v-validate="'required'" name="Klasifikasi Pemohon" :class="{
                  'is-invalid': errors.has('form-1.Klasifikasi Pemohon'),
                }" class="custom-disabled" />
              <span class="text-danger" v-if="errors.has('form-1.Klasifikasi Pemohon')">
                {{ errors.first("form-1.Klasifikasi Pemohon") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="KBLI: *">
              <v-select disabled id="default-select" v-model="form.kbli" :reduce="(kbli) => kbli.kode"
                style="background-color: white !important;" label="kode_deskripsi" :options="dataKBLI" multiple
                v-validate="'required'" name="KBLI" :class="{ 'is-invalid': errors.has('form-1.KBLI') }" />
              <span class="text-danger" v-if="errors.has('form-1.KBLI')">
                {{ errors.first("form-1.KBLI") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Tanggal Permohonan: *">
              <input readonly type="date" v-validate="'required'" name="Tanggal Permohonan" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Permohonan'),
              }" v-model="form.tanggal_pada_permohonan" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Permohonan')">
                {{ errors.first("form-1.Tanggal Permohonan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Jenis Kegiatan: *">
              <b-form-input readonly v-model="form.jenis_kegiatan" type="text" v-validate="'required'"
                name="Jenis Kegiatan" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Jenis Kegiatan'),
                }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Kegiatan')">
                {{ errors.first("form-1.Jenis Kegiatan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Lokasi: *">
              <b-form-input readonly type="text" v-validate="'required'" name="Lokasi" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Lokasi'),
              }" v-model="form.lokasi" />
              <span class="text-danger" v-if="errors.has('form-1.Lokasi')">
                {{ errors.first("form-1.Lokasi") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Jenis Proyek *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="form.jenis_proyek"
                label="nama" index="nama" :options="dataJenisProyek" v-validate="'required'" name="Jenis Proyek"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Proyek') }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Proyek')">
                {{ errors.first("form-1.Jenis Proyek") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Risiko *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="form.risiko"
                label="nama" index="nama" :options="dataRisiko" v-validate="'required'" name="Risiko"
                :class="{ 'is-invalid': errors.has('form-1.Risiko') }" />
              <span class="text-danger" v-if="errors.has('form-1.Risiko')">
                {{ errors.first("form-1.Risiko") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Skala Usaha *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="form.skala_usaha"
                label="nama" index="nama" :options="dataSkalaUsaha" v-validate="'required'" name="Skala Usaha"
                :class="{ 'is-invalid': errors.has('form-1.Skala Usaha') }" />
              <span class="text-danger" v-if="errors.has('form-1.Skala Usaha')">
                {{ errors.first("form-1.Skala Usaha") }}
              </span>
            </b-form-group>
          </b-col>



          <b-col md="6">
            <b-form-group label-for="form" label="Potensi PNBP *">
              <b-form-input readonly v-validate="'required'" name="Potensi PNBP" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Potensi PNBP'),
              }" v-model="form.potensi_pnbp" type="text" />
              <span class="text-danger" v-if="errors.has('form-1.Potensi PNBP')">
                {{ errors.first("form-1.Potensi PNBP") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Tanggal Proses: *">
              <input readonly type="date" v-validate="'required'" name="Tanggal Proses" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Proses'),
              }" v-model="form.tanggal_proses" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Proses')">
                {{ errors.first("form-1.Tanggal Proses") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Reklamasi: *">
              <b-form-select class="custom-disabled" disabled v-model="form.reklamasi" v-validate="'required'"
                name="Reklamasi" :class="{ 'is-invalid': errors.has('form-1.Reklamasi') }"
                :options="dataReklamasi"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Reklamasi')">
                {{ errors.first("form-1.Reklamasi") }}
              </span>
            </b-form-group>
          </b-col>

          <!-- <b-col md="6">
            <b-form-group label-for="form" label="Prioritas: *">
              <b-form-select
                readonly
                v-model="form.prioritas"
                v-validate="'required'"
                name="Prioritas"
                :class="{ 'is-invalid': errors.has('form-1.Prioritas') }"
                :options="optionsPrioritas"
              ></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Prioritas')">
                {{ errors.first("form-1.Prioritas") }}
              </span>
            </b-form-group>
          </b-col> -->

          <b-col md="6">
            <b-form-group label-for="form" label="PSN: *">
              <b-form-select class="custom-disabled" disabled id="default-select" v-model="form.psn"
                :options="['PSN', 'Non PSN']" v-validate="'required'" name="PSN"
                :class="{ 'is-invalid': errors.has('form-1.PSN') }" />
              <span class="text-danger" v-if="errors.has('form-1.PSN')">
                {{ errors.first("form-1.PSN") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label-for="form" label="Bentuk Usaha: *">
              <b-form-select class="custom-disabled" disabled v-model="form.bentuk_usaha"
                v-validate="'required'" name="Bentuk Usaha" :class="{ 'is-invalid': errors.has('form-1.Bentuk Usaha') }"
                :options="optionsBentukUsaha"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Bentuk Usaha')">
                {{ errors.first("form-1.Bentuk Usaha") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
                  <b-form-group label="Nilai Investasi: *" label-for="username">
                    <currency-input readonly
                      v-model="form.nilai_investasi"
                      name="Nilai Investasi"
                      id="name"
                      v-validate="'required'"
                      :inputClass="{
                        'form-control': true,
                        'is-invalid': errors.has('form-1.Nilai Investasi'),
                      }"
                    />

                    <span class="text-danger" v-if="errors.has('form-1.Nilai Investasi')">
                      {{ errors.first('form-1.Nilai Investasi') }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Serapan Tenaga Kerja: *" label-for="username">
                    <b-form-input readonly v-validate="'required'" name="Serapan Tenaga Kerja" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Serapan Tenaga Kerja'),
                    }" id="name" type="number" v-model="form.serapan_tenaga_kerja" />
                    <span class="text-danger" v-if="errors.has('form-1.Serapan Tenaga Kerja')">
                      {{ errors.first("form-1.Serapan Tenaga Kerja") }}
                    </span>
                  </b-form-group>
                </b-col>

          <b-col md="6">
            <b-form-group label-for="form" label="Jenis Permohonan: *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="form.jenis_pnbp"
                :options="[
                  'Area',
                  'Kabel Bawah Laut',
                  'Pipa Air Bersih / Air Baku',
                  'Pipa Selain Air Bersih / Air Baku',
                ]" v-validate="'required'" name="Jenis Permohonan" :multiple="true"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }" @input="resetPNBP" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan')">
                {{ errors.first("form-1.Jenis Permohonan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="form.jenis_pnbp.includes('Area')">
            <b-form-group label-for="form" label="Luas (ha) *">
              <b-form-input readonly min="0" step=".01" type="number" name="Luas" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Luas'),
              }" v-model="form.luas" />
              <span class="text-danger" v-if="errors.has('form-1.Luas')">
                {{ errors.first("form-1.Luas") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="
            form.jenis_pnbp.includes('Kabel Bawah Laut') ||
            form.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') ||
            form.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
          ">
            <b-form-group label-for="form" label="Panjang (di dalam Kws. Konservasi)(km)*">
              <b-form-input readonly min="0" step=".01" type="number" name="Panjang (di dalam Kws. Konservasi)(km)" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Panjang (di dalam Kws. Konservasi)(km)'),
              }" v-model="form.panjang_konservasi" />
              <span class="text-danger" v-if="errors.has('form-1.Panjang (di dalam Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang (di dalam Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="
            form.jenis_pnbp.includes('Kabel Bawah Laut') ||
            form.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') ||
            form.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
          ">
            <b-form-group label-for="form" label="Panjang (di luar Kws. Konservasi)(km)*">
              <b-form-input readonly min="0" step=".01" type="number" name="Panjang (di luar Kws. Konservasi)(km)" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)'),
              }" v-model="form.panjang_nonkonservasi" />
              <span class="text-danger" v-if="errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang (di luar Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Kategori Permohonan: *">
              <b-form-select class="custom-disabled" v-model="form.kategori_permohonan"
                v-validate="'required'" name="Kategori" :class="{ 'is-invalid': errors.has('form-1.Kategori') }"
                :options="optionsKategori" disabled></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Kategori')">
                {{ errors.first("form-1.Kategori") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="form" label="Tipe Permohonan: *">
              <b-form-select class="custom-disabled" disabled v-model="form.tipe_permohonan"
                v-validate="'required'" name="Tipe Permohonan"
                :class="{ 'is-invalid': errors.has('form-1.Tipe Permohonan') }" :options="optionsTipe"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Tipe Permohonan')">
                {{ errors.first("form-1.Tipe Permohonan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="form.tipe_permohonan == 'Multi KBLI'">
            <b-form-group label-for="form" label="Tipe Multi KBLI: *">
              <b-form-select class="custom-disabled" disabled v-model="form.tipe_multi_kbli"
                v-validate="'required'" name="Tipe Multi KBLI"
                :class="{ 'is-invalid': errors.has('form-1.Tipe Multi KBLI') }"
                :options="optionsMultiKBLI"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Tipe Multi KBLI')">
                {{ errors.first("form-1.Tipe Multi KBLI") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="form.tipe_permohonan == 'Multi KBLI'">
            <b-form-group label-for="form" label="Tipe Multi KBLI: *">
              <b-form-select disabled v-model="form.tipe_multi_kbli" v-validate="'required'"
                name="Tipe Multi KBLI" :class="{ 'is-invalid': errors.has('form-1.Tipe Multi KBLI') }"
                :options="optionsMultiKBLI"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Tipe Multi KBLI')">
                {{ errors.first("form-1.Tipe Multi KBLI") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="form.tipe_multi_kbli == 'Mengikuti'">
            <b-form-group label-for="form"  label="Nomor Permohonan Utama: *">
              <b-form-input readonly v-validate="'required'" name="Nomor Permohonan Utama" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Nomor Permohonan Utama'),
              }" id="name" type="text" v-model="form.nomor_permohonan_utama" />
              <span class="text-danger" v-if="errors.has('form-1.Nomor Permohonan Utama')">
                {{ errors.first("form-1.Nomor Permohonan Utama") }}
              </span>

              <span class="text-danger" v-if="status_nomor_error">
                {{ "Nomor Permohonan utama tidak ditemukan, silahkan cek kembali" }}
              </span>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>

          <div class="row justify-content-between mt-5">
            <div class="col-4">
              <div class="text-left"></div>
            </div>
            <div class="col-4">
              <div class="text-right">
                <b-button
                  @click="simpanSelanjutnya()"
                  style="float: right"
                  variant="primary"
                  >Selanjutnya <i class="fa fa-caret-right" />
                </b-button>
              </div>
            </div>
          </div>
        </tab-content>
        <tab-content title="Dokumen" style="background-color: white">
          <b-form>
            <b-row>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">Koordinat</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_1"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                  <span style="color: red; font-size: 12px"
                    >*Ukuran File Maksimal 5MB</span
                  >
                </b-form-group> -->
              </b-col>
              <b-col md="4">
                <b-form-group label-for="form">
                  <!-- <b-button
                    v-if="file_1 == null"
                    disabled
                    variant="primary"
                    @click="simpanFile('kordinat')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanFile('kordinat')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  > -->

                  <b-button
                    variant="success"
                    v-if="form.file_kordinat == null"
                    disabled
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tidak ada data"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-download" /> Download</b-button
                  >
                  <a
                    :href="form.file_kordinat"
                    v-else
                    type="button"
                    class="btn btn-success"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="fa fa-download" /> Download</a
                  >
                </b-form-group>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <div class="divider div-transparent"></div>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">
                  Rencana Bangunan dan Instalasi di Laut
                </p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_2"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                  <span style="color: red; font-size: 12px"
                    >*Ukuran File Maksimal 5MB</span
                  >
                </b-form-group> -->
              </b-col>
              <b-col md="4">
                <!-- <b-button
                  variant="primary"
                  v-if="file_2 == null"
                  disabled
                  @click="simpanFile('bangunan')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                >
                <b-button
                  variant="primary"
                  v-else
                  @click="simpanFile('bangunan')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                > -->
                <!-- <b-button variant="success" v-if="form.file_rencana_bangunan_dan_instalasi_di_laut != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="
                    form.file_rencana_bangunan_dan_instalasi_di_laut == null
                  "
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="form.file_rencana_bangunan_dan_instalasi_di_laut"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                              <hr class="style1 hr-blurry" md="12">
                          </b-col> -->
              <b-col md="12">
                <div class="hr-sect">Rencana Kegiatan</div>
              </b-col>
              <!-- <b-col md="3">
                          
                          </b-col>
                          <b-col md="4">
                          
                          </b-col> -->
              <!-- <b-col md="12" class="divider-col">
                              <hr class="style1" md="12">
                          </b-col> -->

              <b-col md="8">
                <div>
                  Dokumen dasar berupa kegiatan, tujuan dan manfaat kegiatan
                  usaha
                </div>
              </b-col>
              <!-- <b-col md="3">
                              <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group>
                          </b-col> -->

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>

              <b-col md="5">
                <div>Kegiatan eksisting yang dimohonkan</div>
              </b-col>
              <b-col md="3"> </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Rencana jadwal pelaksanaan kegiatan utama dan pendukungnya
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Rencana tapak/site plan kegiatan yang dilengkapi dengan
                  rencana bangunan dan instalasi di laut serta fasilitas
                  penunjangnya
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Deksriptif luasan (Ha) yang dibutuhkan pada lokasi usaha yang
                  dimohonkan per kegiatan utama dan penunjangnya
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Peta lokasi/plotting batas-batas area dan/atau jalur disertai
                  titik koordinat lokasi dengan sistem koordinat lintang
                  (latitude) dan bujur (longitude) berskala minimal 1:50.000.
                </div>
              </b-col>

              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>
                  <p style="font-weight: 900; font-size: 17px">
                    Informasi Pemanfaatan Ruang Laut
                  </p>
                </div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_3"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                  <span style="color: red; font-size: 12px"
                    >*Ukuran File Maksimal 5MB</span
                  >
                </b-form-group> -->
              </b-col>
              <b-col md="4">
                <b-form-group label-for="form">
                  <!-- <b-button
                    v-if="file_3 == null"
                    disabled
                    variant="primary"
                    @click="simpanFile('prl')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  >
                  <b-button
                    v-else
                    variant="primary"
                    @click="simpanFile('prl')"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-cloud-upload" /> Unggah</b-button
                  > -->
                  <!-- <b-button variant="success" v-if="form.file_informasi_prl != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <b-button
                    variant="success"
                    v-if="form.file_informasi_prl == null"
                    disabled
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tidak ada data"
                    class="text-white"
                    style="margin-right: 5px"
                    ><i class="fa fa-download" /> Download</b-button
                  >
                  <a
                    :href="form.file_informasi_prl"
                    v-else
                    type="button"
                    class="btn btn-success"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><i class="fa fa-download" /> Download</a
                  >
                  <!-- <div class="form-check form-switch">
                                      <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                      <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                  </div> -->
                </b-form-group>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>
                  Informasi Pemanfaatan Ruang Laut di sekitar Area Permohonan
                </div>
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>
                  <p style="font-weight: 900; font-size: 17px">
                    Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                    hidrografi, dan oseanografi)
                  </p>
                </div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                  <b-form-file
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                    class="form-control"
                    v-model="file_4"
                    accept=".doc, .docx, .xlsx, .pdf"
                  ></b-form-file>
                  <span style="color: red; font-size: 12px"
                    >*Ukuran File Maksimal 5MB</span
                  >
                </b-form-group> -->
              </b-col>
              <b-col md="4">
                <!-- <b-button
                  v-if="file_4 == null"
                  disabled
                  variant="primary"
                  @click="simpanFile('kondisi')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                >
                <b-button
                  v-else
                  variant="primary"
                  @click="simpanFile('kondisi')"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-cloud-upload" /> Unggah</b-button
                > -->
                <!-- <b-button variant="success" v-if="form.file_data_kondisi_terkini != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                <b-button
                  variant="success"
                  v-if="form.file_data_kondisi_terkini == null"
                  disabled
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Tidak ada data"
                  class="text-white"
                  style="margin-right: 5px"
                  ><i class="fa fa-download" /> Download</b-button
                >
                <a
                  :href="form.file_data_kondisi_terkini"
                  v-else
                  type="button"
                  class="btn btn-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  ><i class="fa fa-download" /> Download</a
                >
              </b-col>
              <!-- <b-col md="12" class="divider-col">
                              <hr class="style1" md="12">
                          </b-col> -->
              <b-col md="12">
                <div class="hr-sect">Ekosistem Sekitar</div>
              </b-col>
              <!-- <b-col md="3">
                          </b-col>
                          <b-col md="4">
                          </b-col> -->
              <!-- <b-col md="12" class="divider-col">
                              <hr class="style1" md="12">
                          </b-col> -->
              <b-col md="5">
                <div>Mangrove</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Lamun</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="8">
                <div>Terumbu karang</div>
              </b-col>

              <b-col md="12">
                <div class="hr-sect">Hidro-oseanografi</div>
              </b-col>
              <!-- <b-col md="3">
                          
                          </b-col>
                          <b-col md="4">
                          
                          </b-col>
                          <b-col md="12" class="divider-col">
                              <hr class="style1" md="12">
                          </b-col> -->
              <b-col md="5">
                <div>Arus</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Gelombang</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Pasang Surut</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <div>Bathimetri</div>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">Profil dasar laut disertai gambar</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">
                  Kondisi/karakteristik sosial ekonomi masyarakat
                </p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-size: 15px">Aksesibilitas lokasi dan sekitar</p>
              </b-col>
              <b-col md="3">
                <!-- <b-form-group label-for="form">
                                  <b-form-file
                                  placeholder="Choose a file or drop it here..."
                                  drop-placeholder="Drop file here..."
                                  plain
                                  class="form-control"
                                  ></b-form-file>
                              </b-form-group> -->
              </b-col>

              <template v-if="form.reklamasi == true">
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Reklamasi
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group label-for="form">
                    <b-form-file
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      plain
                      class="form-control"
                      v-model="file_6"
                      accept=".doc, .docx, .xlsx, .pdf"
                    ></b-form-file>
                    <span style="color: red; font-size: 12px"
                      >*Ukuran File Maksimal 5MB</span
                    >
                  </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="form">
                    <!-- <b-button
                      v-if="file_6 == null"
                      disabled
                      variant="primary"
                      @click="simpanFile('reklamasi')"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    >
                    <b-button
                      v-else
                      variant="primary"
                      @click="simpanFile('reklamasi')"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    > -->
                    <!-- <b-button variant="success" v-if="form.file_persyaratan_reklamasi != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button
                      variant="success"
                      v-if="form.file_persyaratan_reklamasi == null"
                      disabled
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Tidak ada data"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-download" /> Download</b-button
                    >
                    <a
                      :href="form.file_persyaratan_reklamasi"
                      v-else
                      type="button"
                      class="btn btn-success"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><i class="fa fa-download" /> Download</a
                    >
                    <!-- <div class="form-check form-switch">
                                          <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                          <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                      </div> -->
                  </b-form-group>
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Rencana pengambilan sumber material reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group label-for="form">
                                      <b-form-file
                                      placeholder="Choose a file or drop it here..."
                                      drop-placeholder="Drop file here..."
                                      plain
                                      class="form-control"
                                      ></b-form-file>
                                  </b-form-group> -->
                </b-col>

                <b-col md="5">
                  <div>Rencana pemanfaatan lahan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group label-for="form">
                                      <b-form-file
                                      placeholder="Choose a file or drop it here..."
                                      drop-placeholder="Drop file here..."
                                      plain
                                      class="form-control"
                                      ></b-form-file>
                                  </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Gambaran umum pelaksanaan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group label-for="form">
                                      <b-form-file
                                      placeholder="Choose a file or drop it here..."
                                      drop-placeholder="Drop file here..."
                                      plain
                                      class="form-control"
                                      ></b-form-file>
                                  </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Jadwal rencana pelaksanaan reklamasi</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group label-for="form">
                                      <b-form-file
                                      placeholder="Choose a file or drop it here..."
                                      drop-placeholder="Drop file here..."
                                      plain
                                      class="form-control"
                                      ></b-form-file>
                                  </b-form-group> -->
                </b-col>
              </template>

              <template>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Lainnya
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group label-for="form">
                    <b-form-file
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      plain
                      class="form-control"
                      v-model="file_5"
                      accept=".doc, .docx, .xlsx, .pdf"
                    ></b-form-file>
                    <span style="color: red; font-size: 12px"
                      >*Ukuran File Maksimal 5MB</span
                    >
                  </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <b-form-group label-for="form">
                    <!-- <b-button
                      v-if="file_5 == null"
                      disabled
                      variant="primary"
                      @click="simpanFile('lain')"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    >
                    <b-button
                      v-else
                      variant="primary"
                      @click="simpanFile('lain')"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-cloud-upload" /> Unggah</b-button
                    > -->
                    <!-- <b-button variant="success" v-if="form.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button
                      variant="success"
                      v-if="form.file_persyaratan_lain == null"
                      disabled
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Tidak ada data"
                      class="text-white"
                      style="margin-right: 5px"
                      ><i class="fa fa-download" /> Download</b-button
                    >
                    <a
                      :href="form.file_persyaratan_lain"
                      v-else
                      type="button"
                      class="btn btn-success"
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                      ><i class="fa fa-download" /> Download</a
                    >
                    <!-- <div class="form-check form-switch">
                                      <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                      <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                  </div> -->
                  </b-form-group>
                </b-col>
                
              </template>
              <!-- <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
              <b-col md="5">
                <p style="font-weight: 900; font-size: 17px">Link Dokumen</p>
              </b-col>
              <b-col md="7">
                <b-form-input readonly
                  v-model="form.url_bahan_rapat"
                  placeholder="Silahkan masukkan link dokumen dari Cloud Storage, Seperti Google Drive, Dropbox, dll."
                ></b-form-input readonly>
              </b-col> -->
              <b-col md="12" class="divider-col">
                <hr class="style1" md="12" />
              </b-col>
            </b-row>
          </b-form>
        </tab-content>
      </form-wizard>
    </Widget>
  </div>
</template>
  
  <script>
import Vue from "vue";
import Widget from "@/components/Widget/Widget";
import vSelect from "vue-select";
import axios from "axios";
import Swal from "sweetalert2";
import { formatDate } from "../../helper/helpernew";
import Profil from "../Perizinan/Dokumen/Detail/Profil/Profil.vue";
import CurrencyInput from "../../components/CurrencyInput/CurrencyInput.vue";

export default {
  components: {
    Widget,
    vSelect,
    formatDate,
    Profil,
    CurrencyInput
  },
  data() {
    return {
      progress: 1,
      id_permohonan: localStorage.getItem("id_permohonan"),
      tipe: localStorage.getItem("tipe_pemohon"),
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      form: {},
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      dataSkalaUsaha: ["Besar", "Menengah", "Mikro"],
      dataPSN: ["PSN", "Non PSN"],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      inputFiles: [],
      form: [],
      dataUser: [],
      file_1: null,
      file_2: null,
      file_3: null,
      file_4: null,
      file_5: null,
      file_6: null,
      file_7: null,
      dataJenisProyek: [],
      dataRisiko: [],
      dataSkalaUsaha: [],
      dataStatusVerdok: [],
      dataPerDokumen: [],
      dataUser: [],
      dataTTD: [],
      jenisPertemuan: "Langsung",
      optionsBentukUsaha: [
        { value: 'BUMN', text: "BUMN" },
        { value: 'BUMD', text: "BUMD" },
        { value: 'Lainnya', text: "Lainnya" },
      ],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataKBLI: [],
      dataLokasi: [],
      dataKlasifikasi: [],
    };
  },
  mounted() {
    this.getProvinsi();
    this.getRisiko();
    this.getJenisProyek();
    this.getSkalaUsaha();
    this.getKBLI();
    this.getKlasifikasi();
    if (this.id_permohonan != null && this.id_permohonan != undefined) {
      this.loadData();
    }
  },
  methods: {
    simpanSelanjutnya() {
      let btn = document.getElementById("selanjutnya");
            btn?.click();
      // this.$validator.validateAll().then((result) => {
      //   console.log("masuk");

      //   this.simpanForm();
      //   //   if (
      //   //     this.form.nomor_permohonan != null &&
      //   //     this.form.nomor_permohonan != "" &&
      //   //     this.form.npwp_pemohon != null &&
      //   //     this.form.npwp_pemohon != "" &&
      //   //     this.form.nama_pemohon != null &&
      //   //     this.form.nama_pemohon != "" &&
      //   //     this.form.jabatan_pemohon != null &&
      //   //     this.form.jabatan_pemohon != "" &&
      //   //     this.form.instansi_pemohon != null &&
      //   //     this.form.instansi_pemohon != "" &&
      //   //     this.form.alamat_pemohon != null &&
      //   //     this.form.alamat_pemohon != "" &&
      //   //     this.form.no_hp_pemohon != null &&
      //   //     this.form.no_hp_pemohon != "" &&
      //   //     this.form.no_telepon_pemohon != null &&
      //   //     this.form.no_telepon_pemohon != "" &&
      //   //     this.form.email_pemohon != null &&
      //   //     this.form.email_pemohon != "" &&
      //   //     this.form.provinsi != null &&
      //   //     this.form.provinsi != "" &&
      //   //     this.form.kabupaten != null &&
      //   //     this.form.kabupaten != "" &&
      //   //     this.form.kecamatan != null &&
      //   //     this.form.kecamatan != "" &&
      //   //     this.form.jenis_kegiatan != null &&
      //   //     this.form.jenis_kegiatan != "" &&
      //   //     this.form.reklamasi != null &&
      //   //     this.form.nama_perairan != null &&
      //   //     this.form.nama_perairan != "" &&
      //   //     this.form.psn != null &&
      //   //     this.form.jenis_pnbp != null &&
      //   //     this.form.kedalaman != null &&
      //   //     this.form.kedalaman != ""
      //   //   ) {
      //   //     console.log("berhasil");

      //   //   }
      // });
    },
    updateProgress(prevIndex, nextIndex) {
      console.log(prevIndex + ":" + nextIndex);
      if (nextIndex >= 0) {
        if (nextIndex == 1) {
        } else if (nextIndex == 2) {
        }
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    finish() {
      this.$router.push("/app/permohonan/berusaha");
        localStorage.removeItem("id_permohonan");
        
      // console.log(this.form.status_permohonan)
      // if (
      //   this.form.file_kordinat == null || this.form.file_data_kondisi_terkini == null || this.form.file_informasi_prl == null || this.form.file_persyaratan_lain == null || this.form.file_rencana_bangunan_dan_instalasi_di_laut == null
      // ) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Dokumen Tidak Lengkap",
      //     text: "Silahkah lengkapi dokumen Anda",
      //   });
      // } else {
      //   this.simpanUrl();
      //   this.$router.push("/app/permohonan/berusaha");
      //   localStorage.removeItem("id_permohonan");
      // }
    
    },

    resetPNBP() {
      this.form.luas = null;
      this.form.panjang_konservasi = null;
      this.form.panjang_nonkonservasi = null;
    },

    loadData() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      axios
        .get(this.baseapi + "api/permohonan/" + id_permohonan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi?sort=id,ASC", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
          this.getKabupaten();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKabupaten() {
      axios
        .get(
          this.baseapi +
            "api/kabupaten?filter=nama_provinsi,=," +
            this.form.provinsi,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKabupaten = response.data.data;
          this.getKecamatan();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKecamatan() {
      axios
        .get(
          this.baseapi +
            "api/kecamatan?filter=nama_kabupaten,=," +
            this.form.kabupaten,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataKecamatan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async simpanUrl() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      const formData = new FormData();
      formData.append("url_bahan_rapat", this.form.url_bahan_rapat);
      formData.append("status_permohonan", 'Permohonan telah disubmit oleh pemohon');
      axios.post(this.baseapi + "api/permohonan/" + id_permohonan, formData, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      });
    },

    format_date(val, format) {
      if (val) return formatDate(val, format);
    },

    async simpanForm() {
      const id_permohonan = localStorage.getItem("id_permohonan");
      this.form.tipe_pemohon = localStorage.getItem("tipe_pemohon");
      this.form.tanggal_permohonan = this.format_date(Date.now(), "YYYY-MM-DD");
      if (id_permohonan != null) {
        axios
          .post(
            this.baseapi + "api/permohonan/" + id_permohonan,
            {
              nib_pemohon: this.form.nib_pemohon,
              nama_pemohon: this.form.nama_pemohon,
              email_pemohon: this.form.email_pemohon,
              tanggal_pada_permohonan: this.form.tanggal_pada_permohonan,
              tangal_masuk_oss: this.form.tanggal_proses,
              nomor_permohonan: this.form.nomor_permohonan,
              nomor_proyek: this.form.nomor_proyek,
              klasifikasi_pemohon: this.form.klasifikasi_pemohon,
              kbli: this.form.kbli,
              jenis_kegiatan: this.form.jenis_kegiatan,
              lokasi: this.form.lokasi,
              nama_perairan: this.form.nama_perairan,
              jenis_proyek: this.form.jenis_proyek,
              risiko: this.form.risiko,
              skala_usaha: this.form.skala_usaha,
              jenis_pnbp: this.form.jenis_pnbp,
              luas: this.form.luas,
              panjang_konservasi: this.form.panjang_konservasi,
              panjang_nonkonservasi: this.form.panjang_nonkonservasi,
              tanggal_proses: this.form.tanggal_proses,
              catatan_verdok: null,
              bentuk_usaha: this.form.bentuk_usaha,
              reklamasi: this.form.reklamasi,
              npwp_pemohon: this.form.npwp_pemohon,
              psn: this.form.psn,
            },
            {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((response) => {
            let btn = document.getElementById("selanjutnya");
            btn?.click();
            Swal.fire("Berhasil", "" + response.data.message + "", "success");
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        axios
          .post(
            this.baseapi + "api/permohonan",
            {
              nib_pemohon: this.form.nib_pemohon,
              nama_pemohon: this.form.nama_pemohon,
              email_pemohon: this.form.email_pemohon,
              tanggal_pada_permohonan: this.form.tanggal_pada_permohonan,
              tangal_masuk_oss: this.form.tanggal_proses,
              nomor_permohonan: this.form.nomor_permohonan,
              nomor_proyek: this.form.nomor_proyek,
              klasifikasi_pemohon: this.form.klasifikasi_pemohon,
              kbli: this.form.kbli,
              jenis_kegiatan: this.form.jenis_kegiatan,
              lokasi: this.form.lokasi,
              nama_perairan: this.form.nama_perairan,
              jenis_proyek: this.form.jenis_proyek,
              risiko: this.form.risiko,
              skala_usaha: this.form.skala_usaha,
              jenis_pnbp: this.form.jenis_pnbp,
              luas: this.form.luas,
              panjang_konservasi: this.form.panjang_konservasi,
              panjang_nonkonservasi: this.form.panjang_nonkonservasi,
              tanggal_proses: this.form.tanggal_proses,
              catatan_verdok: null,
              bentuk_usaha: this.form.bentuk_usaha,
              reklamasi: this.form.reklamasi,
              npwp_pemohon: this.form.npwp_pemohon,
              psn: this.form.psn,
              status_permohonan: 'Permohonan telah dibuat oleh pemohon'
            },
            {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            }
          )
          .then((response) => {
            let btn = document.getElementById("selanjutnya");
            btn?.click();
            localStorage.setItem("id_permohonan", response.data.data.id);
            Swal.fire("Berhasil", "" + response.data.message + "", "success");
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    simpanFile(jenis) {
      const id_permohonan = localStorage.getItem("id_permohonan");
      let formData = new FormData();
      if (jenis == "kordinat") {
        formData.append("file_kordinat", this.file_1);
      } else if (jenis == "bangunan") {
        formData.append(
          "file_rencana_bangunan_dan_instalasi_di_laut",
          this.file_2
        );
      } else if (jenis == "prl") {
        formData.append("file_informasi_prl", this.file_3);
      } else if (jenis == "kondisi") {
        formData.append("file_data_kondisi_terkini", this.file_4);
      } else if (jenis == "lain") {
        formData.append("file_persyaratan_lain", this.file_5);
      } else if (jenis == "reklamasi") {
        formData.append("file_persyaratan_reklamasi", this.file_6);
      } 

      axios
        .post(this.baseapi + "api/permohonan/" + id_permohonan, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.$toasted.success("Berhasil Diunggah");
          this.file_1 = null;
          this.file_2 = null;
          this.file_3 = null;
          this.file_4 = null;
          this.file_5 = null;
          this.file_6 = null;
          this.loadData();
          return response;
        })
        .catch((error) => {
          this.$toasted.danger("Gagal Diunggah");
          return error;
        });
    },
    onChangeInputFiles(e) {
      const files = [];
      let i = 0;
      for (i; i < e.target.files.length; i += 1) {
        files.push(e.target.files[i]);
      }

      Vue.set(this, "inputFiles", files);
    },
    removeFiles() {
      Vue.set(this, "inputFiles", []);
    },

    // mendapatkan data jenis proyek
    getJenisProyek() {
      axios
        .get(this.baseapi + "api/jenis_proyek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisProyek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // mendapatkan data kbli
    getLokasi() {
      axios
        .get(this.baseapi + "api/provinsi?sort=id,ASC", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataLokasi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKBLI() {
      axios
        .get(this.baseapi + "api/kbli", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKBLI = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    //get Klasifikasi

    getKlasifikasi() {
      axios
        .get(this.baseapi + "api/klasifikasi_pemohon", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKlasifikasi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get risiko
    getRisiko() {
      axios
        .get(this.baseapi + "api/risiko", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataRisiko = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get skala usaha
    getSkalaUsaha() {
      axios
        .get(this.baseapi + "api/skala_usaha", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataSkalaUsaha = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    filterKBLI(id){
      // return this.dataKBLI.filter(item => [2, 3, 4, 3].includes(item.id)).map(item => item.name)
      return this.dataKBLI.find(x => x.kode == id).kode_deskripsi
    },
    nextDokumen() {
      document.getElementById("next").click();
    },
  },
};
</script>